import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import ConfirmButton from './ConfirmButton';
import './_styles_/ResetFieldButton.css';

export const RESET_BUTTON_WIDTH_IN_PX = 20;

ResetFieldButton.propTypes = {
    onReset: PropTypes.func.isRequired,
};

function ResetFieldButton(props) {
    const {
        onReset,
    } = props;
    const { t } = useTranslation();
    return (
        <ConfirmButton
            onConfirm={onReset}
            message={t('misc.reset-field-value')}
            className="reset-field-button"
            title={t('button.reset')}
            tabIndex={-1}
        >
            <FontAwesomeIcon icon="undo" />
        </ConfirmButton>
    );
}

export default ResetFieldButton;
